import { throttle, takeLeading, put } from 'redux-saga/effects';

import HospitalAPI from 'lib/api/HospitalAPI';
import createRequestSaga from 'store/helpers/createRequestSaga';
import { openSnackbar } from 'features/snackbar';
import { logout } from 'store/reducers/accounts';
import {
  DELETE_HOSPITAL_DAY_HOLIDAY,
  DELETE_HOSPITAL_HOLIDAY,
  GET_HOSPITAL_DETAIL,
  UPDATE_HOSPITAL,
  CREATE_HOSPITAL,
} from '.';

const getHospitalDetailSaga = createRequestSaga(
  GET_HOSPITAL_DETAIL,
  HospitalAPI.getHospitalDetail,
);
const updateHospitalSaga = createRequestSaga(
  UPDATE_HOSPITAL,
  HospitalAPI.updateHospital,
  function* () {
    yield put(openSnackbar('수정되었습니다'));
  },
);
const deleteHospitalHolidaySaga = createRequestSaga(
  DELETE_HOSPITAL_HOLIDAY,
  HospitalAPI.deleteHospitalHoliday,
);
const deleteHospitalDayHolidaySaga = createRequestSaga(
  DELETE_HOSPITAL_DAY_HOLIDAY,
  HospitalAPI.deleteHospitalDayHoliday,
);
const createHospitalSaga = createRequestSaga(
  CREATE_HOSPITAL,
  HospitalAPI.createHospital,
  function* () {
    yield put(openSnackbar('등록신청이 접수되었습니다'));
    yield put(logout());
  },
);

export default function* hospitalsSaga() {
  yield throttle(1000, GET_HOSPITAL_DETAIL, getHospitalDetailSaga);
  yield takeLeading(UPDATE_HOSPITAL, updateHospitalSaga);
  yield takeLeading(DELETE_HOSPITAL_HOLIDAY, deleteHospitalHolidaySaga);
  yield takeLeading(DELETE_HOSPITAL_DAY_HOLIDAY, deleteHospitalDayHolidaySaga);
  yield takeLeading(CREATE_HOSPITAL, createHospitalSaga);
}
